import styled from 'styled-components'

export const CityInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
`

export const CityDesc = styled.p`
  width: 100%;
`

export const CityPhoto = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  img {
    width:100%;
    max-width: 1000px;
    height: auto;

    border-radius: 10px;
  }
`